export interface CutOffOptions {
  morningCutOff: number;
  eveningCutOff: number;
  cancelCutOff: number;
  modifCutOff: number;
}
